import { InlineStyle } from '../enums/inlineStyle'
import { StyleCommand } from '../enums/styleCommands'

export const commandToStyle: Record<StyleCommand, InlineStyle> = {
  [StyleCommand.Bold]: InlineStyle.Bold,
  [StyleCommand.Italic]: InlineStyle.Italic,
  [StyleCommand.Underline]: InlineStyle.Underline,
}
